export enum Status {
  Active = 'Active',
  CancellationRequested = 'CancellationRequested',
  AwaitingClosure = 'AwaitingClosure',
  Closed = 'Closed'
}

export enum RemoteTerminalStatus {
  Active = 'active',
  Inactive = 'inactive',
}
